import { render, staticRenderFns } from "./ScrollForm.vue?vue&type=template&id=468bddaa&scoped=true&"
import script from "./ScrollForm.vue?vue&type=script&lang=js&"
export * from "./ScrollForm.vue?vue&type=script&lang=js&"
import style0 from "./ScrollForm.vue?vue&type=style&index=0&id=468bddaa&lang=less&scoped=true&"
import style1 from "./ScrollForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bddaa",
  null
  
)

export default component.exports